module.exports = __webpack_public_path__ + "static/media/banner_s_04.d1bae8d2.jpg";